<template>
  <vs-row vs-type="flex" vs-w="12" id="comparativeBranchReportPage">
    <vs-popup :active.sync="branchEditActive" title="Şube Seçimi Düzenleme">
      <vs-row vs-type="flex" vs-w="12">
        <vs-row id="branchEditHeader" vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" vs-w="12">
            <vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <vs-col vs-type="flex" vs-align="center" vs-justify="space-between">
                  <span class="d-block text-primary text-medium-small weight-600">
                    Şube Sıralamaları
                  </span>
                  <div class="d-flex weight-600 text-small">
                    <span class="text-primary mr-1">
                      {{ selectedBranches.length }}
                    </span>
                    /
                    <span class="ml-1 mr-2">
                      {{ maxFittedBranchSize }}
                    </span>
                    Şube
                  </div>
                </vs-col>
              </vs-row>
              <vs-row vs-type="flex" vs-w="12">
                <p class="d-block weight-500 text-smaller mt-2">
                  Karşılaştırma raporunda şube sınırı vardır. Bu sınır ekran genişliğinize göre artıp azalmaktadır.</br>
                  Bir
                  şubeyi karşılaştırmaya sokabilmek için öncelikle <b>şube sınırını geçmediğinize</b> emin olun. </br>
                  Şubenin rapora
                  tâbi olup olmayacağını üstüne tıklayarak belirleyebilirsiniz. <b class="text-primary">Kırmızı</b>
                  renkli şubeler karşılaşmaya
                  katılacaktır. </br>
                  Seçilen şubelerin sıralarını <b>sürükle bırak</b> yöntemi ile değiştirebilirsiniz.
                </p>
              </vs-row>
            </vs-row>
          </vs-col>
        </vs-row>
        <vs-divider class="mb-0"></vs-divider>
        <vs-row vs-type="flex" vs-w="12" id="branchEditList">
          <draggable :list="rawBranches" class="cursor-move w-full">
            <div @click="selectRawBranch(rawBranch)" class="w-full my-1 border-divider border-bottom"
                 :class="{'text-primary' : rawBranch.selected}"
                 v-for="(rawBranch, index) in rawBranches"
                 :key="rawBranch.id">
              <vs-list-item class="text-smaller" :title="(index+1) + '. ' + rawBranch.name">
                <vs-button :color="rawBranch.selected ? 'primary' : 'secondary'" icon-pack="feather" icon="icon-eye"
                           size="small"/>
              </vs-list-item>
            </div>
          </draggable>
        </vs-row>
      </vs-row>
    </vs-popup>
    <vs-row
      vs-type="flex"
      vs-w="12"
      id="rawTableOptions"
      class="px-4 py-2 sale-box-shadow low-border-radius bg-white"
      vs-justify="center"
    >
    <vs-row id="panelHeaderRow" vs-type="flex" vs-w="12" vs-justify="space-between">
      <vs-col id="panel-actions" vs-type="flex" class="w-auto" vs-justify="flex-start">
        <vs-row vs-type="flex" vs-w="12">
          <vs-col vs-type="flex" class="w-auto">
              <vx-tooltip text="Yazdır" position="top">
                    <vs-button @click="printReport" color="transparent" class="panel-action text-dark xlarge-button panel-action-box-shadow" icon-pack="feather"
                      icon="icon-printer" />
                  </vx-tooltip>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
      <vs-col vs-type="flex" vs-w="2" class="pr-4">
        <v-select
          class="w-full weight-500 borderSelect"
          @input="reportTypeSelected"
          :clearable="false"
          placeholder="Karşılaştırma Tipi"
          itemid="id"
          label="dName"
          color="primary"
          v-model="tableOptions.accordingTo"
          :options="reportTypes"
          :disabled="reportTypes.length == 0"
        />
      </vs-col>
      <vs-col vs-type="flex" vs-w="5" class="px-2">
        <v-select
          id="tableOptionsAccording"
          v-if="tableOptions.accordingTo.id == 2"
          class="w-full weight-500"
          multiple
          :clearable="false"
          placeholder="Kategori Seçimi"
          itemid="id"
          label="name"
          v-model="tableOptions.accordings"
          :options="categories"
          :selectable="
            (option) =>
              !tableOptions.accordings.some(
                (category) => category.id == option.id
              )
          "
          :disabled="categories.length == 0"
        >
          <template #option="{ name, id }">
            <div class="d-flex align-center">
              <span>{{ name }}</span>
              <span
                v-if="
                  tableOptions.accordings.some((category) => category.id == id)
                "
                class="ml-auto text-xsmaller text-success"
              >Seçildi</span
              >
            </div>
          </template>
        </v-select>
        <v-select
          id="tableOptionsAccording"
          v-else-if="tableOptions.accordingTo.id == 1"
          class="w-full .borderSelect weight-500"
          multiple
          :clearable="false"
          placeholder="Ürün Seçimi"
          :selectable="
            (option) =>
              !tableOptions.accordings.some(
                (product) => product.id == option.id
              )
          "
          itemid="id"
          label="name"
          v-model="tableOptions.accordings"
          :options="products"
          :disabled="products.length == 0"
        >
          <template #option="{ name, id }">
            <div class="d-flex align-center">
              <span>{{ name }}</span>
              <span
                v-if="
                  tableOptions.accordings.some((product) => product.id == id)
                "
                class="ml-auto text-xsmaller text-success"
              >Seçildi</span
              >
            </div>
          </template>
        </v-select>
      </vs-col>
      <vs-col vs-type="flex" vs-w="5" class="pl-4">
        <v-select
          id="tableOptionsBranches"
          class="w-full weight-500"
          multiple
          :clearable="false"
          placeholder="Şube Seçimi"
          itemid="id"
          label="name"
          v-model="rawBranches"
          :options="branches"
          :disabled="branches.length == 0"
          :selectable="
            (option) => !rawBranches.some((branch) => branch.id == option.id)
          "
        >
          <template #option="{ name, id }">
            <div class="d-flex align-center">
              <span>{{ name }}</span>
              <span
                v-if="rawBranches.some((branch) => branch.id == id)"
                class="ml-auto text-xsmaller text-success"
              >Seçildi</span
              >
            </div>
          </template>
        </v-select>
      </vs-col>
    </vs-row>
    <vs-row
      vs-type="flex"
      vs-w="12"
      id="optionalTableOptions"
      class="px-4 py-2 mt-3 sale-box-shadow low-border-radius bg-white"
    >
      <vs-col
        vs-type="flex"
        vs-w="4.5"
        class="pr-2 border-right border-divider"
        vs-align="center"
        vs-justify="space-between"
      >
        <vs-button
          :disabled="!tableOptions.defaultTimeRange"
          @click="tableOptions.defaultTimeRange = range"
          :class="{
            'text-primary': isSelectedRange(range),
            'text-secondaryDark': !isSelectedRange(range),
            'pl-2 mr-2': index == 0,
            'pr-2 ml-2': index == 4,
            'mx-2 px-2': index > 0 && index < 4,
          }"
          :style="[
            !isSelectedRange(range)
              ? { 'border-bottom-width': '0!important' }
              : { 'border-bottom-width': '2px!important' },
          ]"
          type="line"
          :color="isSelectedRange(range) ? 'primary' : 'secondary'"
          class="py-1 px-0 bold"
          v-for="(range, index) in timeRanges"
          :key="range.id"
        >
          {{ range.dName }}
        </vs-button>
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-w="4"
        class="px-4 border-right border-divider"
        vs-align="center"
      >
        <vs-col vs-w="6" class="pr-2" vs-type="flex" vs-align="center">
          <datepicker
            @selected="clearDefaultDateRange"
            placeholder="Başlangıç Tarihi"
            class="w-full filterStartDate"
            :language="turkish"
            :format="format"
            v-model="tableOptions.dateRange.startDate"
          >
          </datepicker>
          <vs-button v-if="tableOptions.dateRange.startDate" icon-pack="feather" icon="icon-x" size="small"
                     color="white" class="text-primary"
                     @click="clearDateRange(0)"/>
        </vs-col>
        <vs-col vs-w="6" class="pl-2" vs-type="flex" vs-align="center">
          <datepicker
            @selected="clearDefaultDateRange"
            placeholder="Bitiş Tarihi"
            class="w-full filterEndDate"
            :language="turkish"
            :format="format"
            size="small"
            v-model="tableOptions.dateRange.endDate"
          >
          </datepicker>
          <vs-button v-if="tableOptions.dateRange.endDate" icon-pack="feather" icon="icon-x" size="small" color="white"
                     class="text-primary"
                     @click="clearDateRange(1)"/>
        </vs-col>
      </vs-col>
      <vs-col vs-type="flex" vs-w="3.5" class="pl-4" vs-align="center">
        <vs-col vs-w="6" class="pr-2">
          <vue-timepicker
            placeholder="Başlangıç Saati"
            class="w-full filter-timepicker"
            :language="turkish"
            v-model="tableOptions.timeRange.startTime"
          ></vue-timepicker>
        </vs-col>
        <vs-col vs-w="6" class="pl-2">
          <vue-timepicker
            placeholder="Bitiş Saati"
            class="w-full filter-timepicker"
            :language="turkish"
            v-model.lazy="tableOptions.timeRange.endTime"
          ></vue-timepicker>
        </vs-col>
      </vs-col>
    </vs-row>
    <vs-row vs-type="flex" vs-w="12"
            class="sale-box-shadow my-3 px-4 py-2 low-border-radius bg-white">
      <vs-row
        v-if="rawBranches.length > 0"
        class="mb-1"
        vs-type="flex"
        vs-w="12"
        id="panelHeaderRow"
        vs-justify="space-between"
      >
<!--        <vs-col vs-type="flex" vs-w="0.5">-->
<!--          <vs-button color="primary" icon-pack="feather" icon="icon-chevron-left" @click="scrollLeft" size="small"/>-->
<!--        </vs-col>-->
        <vs-col id="filter-chips2" vs-w="12" vs-type="flex" vs-align="center" vs-justify="center">
          <vs-row id="selectedBranchChips" vs-type="flex" vs-w="12" vs-justify="center" vs-align="center">
            <vs-button @click="branchEditActive = true" class="mr-4"
                       v-show="rawBranches.length > 0 && selectedBranches.length < rawBranches.length" size="small"
                       color="primary" icon-pack="feather" icon="icon-settings"/>
            <vs-col vs-type="flex" class="w-auto" v-for="chip in rawBranches" :key="chip.id">
              <div class="d-flex w-full" @click="selectRawBranch(chip)">
                <vs-chip closable @click="removeBranch(chip.id)" color="primary"
                         class="panel-action-box-shadow px-1 ml-2 mb-1 weight-600 low-border-radius pointer"
                         :class="{'transparent' : !selectedBranches.some(x=> x.id == chip.id)}">
                  {{ chip.name }}
                </vs-chip>
              </div>
            </vs-col>
          </vs-row>
        </vs-col>
<!--        <vs-col vs-type="flex" vs-w="0.5" vs-justify="flex-end">-->
<!--          <vs-button color="primary" icon-pack="feather" icon="icon-chevron-right" @click="scrollRight" size="small"/>-->
<!--        </vs-col>-->
      </vs-row>
      <vs-divider></vs-divider>
      <vs-row vs-type="flex" vs-w="12" class="comparativeInnerTableOptions">
        <vs-col vs-type="flex" vs-w="12" vs-align="center">
          <vs-input
            v-model="filterString"
            class="w-full border-radius border-all mr-2"
            size="small"
            placeholder="Arama"
          />
<!--          <vx-tooltip-->
<!--            position="left"-->
<!--            title="Ürün Kırılımlarını Parçala"-->
<!--            color="primary"-->
<!--            text="Ürün kırılımları parçalı özelliği her bir ürün varyantının kendine has bir ürünmüş gibi karşılaştırılmasını sağlar."-->
<!--          >-->
<!--            <vs-button-->
<!--              @click="tableOptions.isSharded = false"-->
<!--              v-if="tableOptions.isSharded"-->
<!--              color="success"-->
<!--              icon-pack="feather"-->
<!--              icon="icon-eye"-->
<!--            />-->
<!--            <vs-button-->
<!--              @click="tableOptions.isSharded = true"-->
<!--              v-else-->
<!--              color="primary"-->
<!--              icon-pack="feather"-->
<!--              icon="icon-eye-off"-->
<!--            />-->
<!--          </vx-tooltip>-->
        </vs-col>
      </vs-row>
      <vs-divider></vs-divider>
      <vs-row vs-type="flex" vs-w="12" id="comparativeItem">
        <transition name="slide-fade" v-for="(reportItem, index) in report" :key="reportItem.branch.id">
          <vs-col
            vs-type="block"
            style="min-width: 600px;"
            :vs-w="12 / report.length"
            class="px-2"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-row vs-type="flex" vs-w="12" class="comparativeBranchOverview">
              <span class="text-primary weight-600 text-medium-small">
                 {{ index + 1 }}-{{ reportItem.branch.name }}
              </span>
                <vs-row vs-type="flex" vs-w="12" vs-align="center" class="mt-1">
                  <vs-col
                    vs-type="flex"
                    vs-w="5"
                    vs-align="center"
                    class="text-secondaryDark weight-600 text-xsmall"
                  >
                    <span> Toplam Satış Adeti: </span>
                    <span class="weight-600 text-small text-primary ml-2">
                    {{ reportItem.totalQuantity.toLocaleString() }} Adet
                  </span>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="7"
                    vs-align="center"
                    vs-justify="flex-end"
                    class="text-secondaryDark weight-600 text-xsmall"
                  >
                    <span> Toplam Satış Tutarı: </span>
                    <span class="weight-600 text-small text-primary ml-2">
                    {{ $toCurrency(reportItem.totalAmount) }}
                  </span>
                  </vs-col>
                </vs-row>
                <vs-row vs-type="flex" vs-w="12" class="mt-2">
                  <vs-col
                    vs-type="flex"
                    vs-w="5"
                    vs-align="center"
                    class="text-secondaryDark weight-600 text-xsmall"
                  >
                    <span> Toplam Satış Maaliyeti: </span>
                    <span class="weight-600 text-small text-primary ml-2">
                    {{ $toCurrency(reportItem.totalCost) }}
                  </span>
                  </vs-col>
                  <vs-col
                    vs-type="flex"
                    vs-w="7"
                    vs-justify="flex-end"
                    vs-align="center"
                    class="text-secondaryDark weight-600 text-xsmall"
                  >
                    <span> Toplam Kâr: </span>
                    <span class="weight-600 text-small text-primary ml-2">
                    {{ $toCurrency(reportItem.totalProfit) }}
                  </span>
                  </vs-col>
                </vs-row>
              </vs-row>
              <vs-divider></vs-divider>
              <vs-row vs-type="flex" vs-w="12" class="comparativeItemList">
                <vs-table
                  class="w-full"
                  v-model="selected"
                  id="comparativeBranchReportTable"
                  :data="reportItem.accordings"
                >
                  <template slot="thead">
                    <vs-th class="w-3/12 px-1">
                      <vs-button
                        class="p-1 weight-600"
                        icon-pack="feather"
                        :icon="sortBy == 0 ? sortingHeadIcon : null"
                        color="primary"
                        type="flat"
                        @click="setSortingOptions(0)"
                      >Ürün
                      </vs-button>
                    </vs-th>
                    <vs-th class="w-2/12 px-1">
                      <vs-button
                        class="p-1 weight-600"
                        icon-pack="feather"
                        :icon="sortBy == 2 ? sortingHeadIcon : null"
                        color="primary"
                        type="flat"
                        @click="setSortingOptions(2)"
                      >Adet
                      </vs-button>
                    </vs-th>
                    <vs-th class="w-3/12">
                      <vs-button
                        class="p-1 weight-600"
                        icon-pack="feather"
                        :icon="sortBy == 1 ? sortingHeadIcon : null"
                        color="primary"
                        type="flat"
                        @click="setSortingOptions(1)"
                      >Tutar
                      </vs-button>
                    </vs-th>
                    <vs-th class="w-2/12">
                      <vs-button
                        class="p-1 weight-600"
                        icon-pack="feather"
                        :icon="sortBy == 4 ? sortingHeadIcon : null"
                        color="primary"
                        type="flat"
                        @click="setSortingOptions(4)"
                      >Maaliyet
                      </vs-button>
                    </vs-th>
                    <vs-th class="w-2/12">
                      <vs-button
                        class="p-1 weight-600"
                        icon-pack="feather"
                        :icon="sortBy == 3 ? sortingHeadIcon : null"
                        color="primary"
                        type="flat"
                        @click="setSortingOptions(3)"
                      >Kâr
                      </vs-button>
                    </vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <div
                      style="display: contents"
                      :key="indextr"
                      v-for="(tr, indextr) in $isNullOrEmpty(filterString)
                      ? data
                      : data.filter((x) =>
                          x.product.name
                            .toLowerCase()
                            .includes(filterString.toLowerCase())
                        )"
                    >
                      <vs-tr
                        class="weight-500"
                        :data="tr"
                        :class="{ 'bg-secondary2': indextr % 2 == 0 }"
                      >
                        <vs-td class="text-center">
                          {{ tr.product.name }}
                        </vs-td>
                        <vs-td class="w-2/12 text-center">
                          {{ tr.quantity.toLocaleString() }}
                        </vs-td>
                        <vs-td class="w-3/12 text-center">
                          {{ $toCurrency(tr.amount) }}
                        </vs-td>
                        <vs-td class="w-2/12 text-center">
                          {{ $toCurrency(tr.cost) }}
                        </vs-td>
                        <vs-td class="w-2/12 text-center">
                          {{ $toCurrency(tr.profit) }}
                        </vs-td>
                        <td class="td-check active-expanded">
                          <feather-icon
                            v-if="!tr.expanded"
                            icon="ChevronDownIcon"
                            svgClasses="h-5 w-5"
                            style="top: 8px; right: 5px"
                          />
                          <feather-icon
                            v-else
                            icon="ChevronUpIcon"
                            svgClasses="h-5
                      w-5"
                            class="ml-auto"
                            style="top: 8px; right: 5px"
                          />
                        </td>
                      </vs-tr>
                      <transition name="slide-fade">
                        <vs-tr
                          v-if="tr.expanded"
                          :class="{ 'bg-secondary2': indextr % 2 == 0 }"
                        >
                          <vs-td
                            :colspan="getColSpan(tr.sizes.length)"
                            v-for="(size, index) in tr.sizes"
                            :key="index"
                          >
                            <vs-tr
                              class="d-flex"
                              :class="{ 'bg-secondary2': indextr % 2 == 0 }"
                            >
                              <vs-td class="w-4/12">
                              <span class="text-primary weight-600 text-xsmall">
                                {{ size.sizeName }}
                              </span>
                              </vs-td>
                              <vs-td class="w-3/12">
                              <span
                                class="text-secondary weight-500 text-xsmall"
                              >
                                Adet
                              </span>
                              </vs-td>
                              <vs-td class="w-5/12">
                              <span
                                class="text-secondary weight-500 text-xsmall"
                              >
                                Tutar
                              </span>
                              </vs-td>
                            </vs-tr>
                            <vs-divider class="my-1"></vs-divider>
                            <vs-tr
                              :class="{ 'bg-secondary2': indextr % 2 == 0 }"
                              class="d-flex"
                              v-for="variant in size.variants"
                              :key="variant.variantId"
                            >
                              <vs-td class="w-4/12">
                                <vx-tooltip
                                  position="top"
                                  :title="variant.variantName"
                                  color="primary"
                                >
                                  <template slot="content">
                                    <vs-row
                                      class="weight-500 text-xsmall text-light py-2"
                                      vs-type="flex"
                                      vs-w="12"
                                    >
                                      <vs-row
                                        vs-type="flex"
                                        vs-w="12"
                                        vs-justify="center"
                                      >
                                        <span> Toplam Adet : </span>
                                        <span class="ml-2 weight-600 underline">
                                        {{
                                            getSizeTotalQuantity(
                                              variant.variantId,
                                              tr.sizes
                                            ).toLocaleString()
                                          }}
                                        Adet
                                      </span>
                                      </vs-row>
                                      <vs-row
                                        vs-type="flex"
                                        vs-w="12"
                                        vs-justify="center"
                                        class="mt-1"
                                      >
                                        <span> Toplam Tutar : </span>
                                        <span class="ml-2 weight-600 underline">
                                        {{
                                            $toCurrency(
                                              getSizeTotalAmount(
                                                variant.variantId,
                                                tr.sizes
                                              )
                                            )
                                          }}
                                      </span>
                                      </vs-row>
                                    </vs-row>
                                  </template>
                                  <span
                                    class="text-secondary weight-600 text-xsmall underline pointer"
                                  >
                                  {{ variant.variantName }}
                                </span>
                                </vx-tooltip>
                              </vs-td>
                              <vs-td class="w-3/12">
                              <span
                                class="text-secondary weight-500 text-xsmall"
                              >
                                {{ variant.variantPiece.toLocaleString() }}
                              </span>
                              </vs-td>
                              <vs-td class="w-5/12">
                              <span
                                class="text-secondary weight-500 text-xsmall"
                              >
                                {{ $toCurrency(variant.variantAmount) }}
                              </span>
                              </vs-td>
                            </vs-tr>
                            <vs-divider class="my-1"></vs-divider>
                            <vs-tr
                              class="d-flex"
                              :class="{ 'bg-secondary2': indextr % 2 == 0 }"
                            >
                              <vs-td class="w-4/12">
                              <span
                                class="text-secondary weight-600 text-xsmall"
                              >
                                Toplam
                              </span>
                              </vs-td>
                              <vs-td class="w-3/12">
                              <span
                                class="text-secondary weight-600 text-xsmall"
                              >
                                {{ size.sizePiece.toLocaleString() }}
                              </span>
                              </vs-td>
                              <vs-td class="w-5/12">
                              <span
                                class="text-secondary weight-600 text-xsmall"
                              >
                                {{ $toCurrency(size.sizeAmount) }}
                              </span>
                              </vs-td>
                            </vs-tr>
                          </vs-td>
                        </vs-tr>
                      </transition>
                    </div>
                  </template>
                </vs-table>
              </vs-row>
            </vs-row>
          </vs-col>
        </transition>
      </vs-row>
    </vs-row>
  </vs-row>
</template>

<script>
import draggable from 'vuedraggable'
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import {tr} from "vuejs-datepicker/src/locale";
import Datepicker from "vuejs-datepicker";
import {getComparativeBranchReport} from "@/api/Reports";
import {
  getReportTypes,
  getDashboardTimeRanges,
} from "@/model/constants/dashboardModels.js";
import {
  filterBranchNameList,
  filterProductNameList,
  filterCategoryList,
} from "@/api/Filter";

export default {
  name: "ComparativeBranchReport",
  data() {
    return {
      branchEditActive: false,
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      selected: null,
      filterString: null,
      format: "dd MM yyyy",
      tableOptions: {},
      reportTypes: [],
      timeRanges: [],
      branches: [],
      rawBranches: [],
      products: [],
      categories: [],
      turkish: tr,
      report: [],
      reportPageClientWidth: 0,
      isPrintMode: false
    };
  },
  components: {
    Datepicker,
    VueTimepicker,
    draggable
  },
  created() {
    this.loadFilterOptions();
    this.clearFilter();
    this.getCategories();
    this.getProducts();
  },
  mounted() {
    this.setReportClientWidth()
  },
  computed: {
    maxFittedBranchSize() {
      let padding = 0.4 * parseFloat(getComputedStyle(document.documentElement).fontSize);
      return ((this.reportPageClientWidth - padding) / 601) | 0
    },
    selectedBranches() {
      return this.rawBranches.filter(x => x.selected == true)
    }
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.setReportClientWidth)
  },
  methods: {
    setReportClientWidth() {
      let rootElement = document.getElementById("comparativeBranchReportPage");
      if(!rootElement) {
        return;
      }
      this.reportPageClientWidth = rootElement.clientWidth;
    },
    clearDefaultDateRange() {
      this.tableOptions.defaultTimeRange = null
    },
    clearDateRange(index) {
      if (index == 0) {
        this.tableOptions.dateRange.startDate = null
      } else if (index == 1) {
        this.tableOptions.dateRange.endDate = null
      }
      if (!this.tableOptions.dateRange.startDate && !this.tableOptions.dateRange.endDate) {
        let nowHour = new Date(Date.now()).getHours();
        this.tableOptions.defaultTimeRange =
          nowHour >= 0 && nowHour <= 2
            ? {
              name: "Yesterday",
              id: 0,
              dName: "Dün",
            }
            : {
              name: "Today",
              id: 1,
              dName: "Bugün",
            };
      }
    },
    scrollBottomAccordings() {
      this.$nextTick(() => {
        let element = document.getElementById("tableOptionsAccording").getElementsByClassName("vs__selected-options")[0];
        element.scrollTop = element.scrollHeight;
      })
    },
    scrollBottomBranches() {
      this.$nextTick(() => {
        let element = document.getElementById("tableOptionsBranches").getElementsByClassName("vs__selected-options")[0];
        element.scrollTop = element.scrollHeight;
      })
    },
    selectRawBranch(rawBranch) {
      if (rawBranch.selected) {
        rawBranch.selected = false
      } else {
        if (this.maxFittedBranchSize > this.selectedBranches.length) {
          rawBranch.selected = true
        } else {
          this.$vs.notify({
            color: "warning",
            title: "Şube Limiti Aşılamaz : " + this.maxFittedBranchSize,
            text: "Öncelikle başka bir şubenin şubenin seçimini kaldırın ve tekrar deneyin.",
          });
        }
      }
    },
    removeBranch(branchId) {
      let index = this.rawBranches.findIndex(x => x.id == branchId);
      if (index > -1) {
        this.rawBranches.splice(index, 1)
      }
    },
    scrollLeft() {
      let element = document.getElementById("filter-chips2");
      element.scrollBy(-50, 0);
    },
    scrollRight() {
      let element = document.getElementById("filter-chips2");
      element.scrollBy(+50, 0);
    },
    getSizeTotalQuantity(sizeId, variants) {
      return variants.reduce((total, current) => {
        return (
          total +
          current.variants.reduce((variantTotal, variantCurrent) => {
            if (variantCurrent.variantId == sizeId) {
              return variantTotal + variantCurrent.variantPiece;
            } else {
              return variantTotal + 0;
            }
          }, 0)
        );
      }, 0);
    },
    getSizeTotalAmount(sizeId, variants) {
      return variants.reduce((total, current) => {
        return (
          total +
          current.variants.reduce((variantTotal, variantCurrent) => {
            if (variantCurrent.variantId == sizeId) {
              return variantTotal + variantCurrent.variantAmount;
            } else {
              return variantTotal + 0;
            }
          }, 0)
        );
      }, 0);
    },
    getColSpan(totalCount) {
      if (totalCount == 1) {
        return 12;
      } else if (totalCount == 2) {
        return 3;
      } else if (totalCount == 3) {
        return 2;
      } else {
        return 1;
      }
    },
    setSortingOptions(val) {
      if (this.sortBy != val) this.sortingHeadIconBool = 1;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          this.sortBy = val;
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          this.sortBy = val;
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.sortBy = 0;
      }
    },
    rawBranchesSelected() {
      if (this.rawBranches.length <= this.maxFittedBranchSize) {
        this.rawBranches.map((rawBranch) => {
          rawBranch.selected = true;
        })
      }
    },
    reportTypeSelected() {
      this.tableOptions.accordings = [];
    },
    getProducts: async function () {
      this.products = await filterProductNameList();
    },
    getCategories: async function () {
      this.categories = await filterCategoryList();
    },
    isSelectedRange(range) {
      if (!this.tableOptions.defaultTimeRange || !range) return false;
      if (range.id === this.tableOptions.defaultTimeRange.id) return true;
      return false;
    },
    loadFilterOptions: async function () {
      this.reportTypes = getReportTypes();
      this.timeRanges = getDashboardTimeRanges();
      this.branches = (await filterBranchNameList()).map(branch => {
        branch.selected = false;
        return branch;
      });
    },
    clearFilter() {
      let nowHour = new Date(Date.now()).getHours();
      this.sortBy = 0;
      this.sortDirection = 0;
      this.tableOptions = {
        accordings: [],
        isSharded: false,
        accordingTo: this.reportTypes[0],
        defaultTimeRange:
          nowHour >= 0 && nowHour <= 2
            ? {
              name: "Yesterday",
              id: 0,
              dName: "Dün",
            }
            : {
              name: "Today",
              id: 1,
              dName: "Bugün",
            },
        dateRange: {
          startDate: null,
          endDate: null,
        },
        timeRange: {
          startTime: null,
          endTime: null,
        },
      };
    },
    getComparativeBranchReport() {
      let timeRange = this.tableOptions.timeRange
      if (timeRange) {
        let startTime = this.tableOptions.timeRange.startTime;
        let endTime = this.tableOptions.timeRange.endTime;
        if (startTime) {
          if (startTime.HH == null || startTime.HH == '') return;
          if (startTime.mm == null || startTime.mm == '') return;
        }
        if (endTime) {
          if (endTime.HH == null || endTime.HH == '') return;
          if (endTime.mm == null || endTime.mm == '') return;
        }
      }
      getComparativeBranchReport(
        this.tableOptions,
        this.sortDirection,
        this.sortBy,
        this.selectedBranches
      )
        .then((res) => {
          if (res && res.status == 200) {
            this.report = res.data;
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Rapor Getirilemedi !",
            });
          }
        })
        .catch((error) => {
          if (error.response.status === 429) {
            this.$vs.notify({
              color: "danger",
              title: "Çok Fazla İstek !",
              text: error.response.data,
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata !",
              text: "Sunucu Bağlantı Hatası !",
            });
          }
        });
    },
    printReport() {
          this.isPrintMode = true;
          this.$nextTick(() => {
const prtHtml = document.getElementById('comparativeBranchReportPage').innerHTML;

// Get all stylesheets HTML
let stylesHtml = '';
for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
  stylesHtml += node.outerHTML;
}

// Open the print window
const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

WinPrint.document.write(`<!DOCTYPE html>
<html>
  <head>
    ${stylesHtml}
  </head>
  <body>
    ${prtHtml}
  </body>
</html>`);

WinPrint.document.close();
window.setTimeout(() => {WinPrint.focus(); WinPrint.print(); WinPrint.close();  this.isPrintMode = false;}, 2000)
           // window.location.reload();
          });
        }
  },
  watch: {
    'tableOptions.timeRange.startTime': function (val) {
      if (!val) return;
      if (val.HH == '' && val.mm == '') {
        this.tableOptions.timeRange.startTime = null;
      }
    },
    'tableOptions.timeRange.endTime': function (val) {
      if (!val) return;
      if (val.HH == '' && val.mm == '') {
        this.tableOptions.timeRange.endTime = null;
      }
    },
    rawBranches: {
      deep: true,
      handler(val, oldVal) {
        this.rawBranchesSelected()
        if (val.length > oldVal.length) this.scrollBottomBranches()
      }
    },
    selected: {
      deep: true,
      handler(val) {
        if (val) {
          let accordingId = val.product.id;
          this.report.forEach((item) => {
            let accordingItem = item.accordings.find(
              (according) => according.product.id == accordingId
            );
            accordingItem.expanded = !accordingItem.expanded;
          });
          this.selected = "";
        }
      },
    },
    tableOptions: {
      deep: true,
      handler(val) {
        if (
          val.accordingTo &&
          this.selectedBranches.length > 0 &&
          val.accordings.length > 0
        ) {
          this.getComparativeBranchReport();
        }
      },
    },
    'tableOptions.accordings': {
      deep: true,
      handler(val, oldVal) {
        if (val && oldVal && val.length > oldVal.length) this.scrollBottomAccordings()
      }
    },
    selectedBranches: {
      deep: true,
      handler(val) {
        if (
          this.tableOptions.accordingTo &&
          val.length > 0 &&
          this.tableOptions.accordings.length > 0
        ) {
          this.getComparativeBranchReport();
        }
      }
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortDirection = null;
          break;
        case 2:
          this.sortDirection = 0;
          break;
        case 3:
          this.sortDirection = 1;
          break;
      }
      this.getComparativeBranchReport();
    },
  },
};
</script>

<style>

#comparativeBranchReportPage .con-vs-chip.transparent {
  color: black !important;
  background-color: rgba(var(--vs-secondary), 1) !important;;
}

#comparativeBranchReportPage .entryDetailRow {
  border-bottom: 0.1rem solid #d3d3d3;
}

.comparativeInnerTableOptions .vs-inputx {
  border: none !important;
}

#comparativeBranchReportPage .vs-table-text {
  justify-content: center;
}

#comparativeBranchReportPage .vs__dropdown-menu {
  max-height: 25vh !important;
  overflow-x: auto !important;
  overflow-y: auto !important;
  width: 100% !important;
  min-width: unset !important;
}

#comparativeBranchReportPage .vs-con-table .vs-table tr tr {
  box-shadow: none !important;
}

#comparativeBranchReportPage .vs-con-table .vs-table tr + tr {
  border-top: 1px dashed rgba(0, 0, 0, 0.2);
}

#comparativeBranchReportPage .borderSelect .vs__dropdown-toggle {
  border: none !important;
  border-bottom: 2px solid rgba(var(--vs-primary), 1) !important;
  border-radius: 0;
  padding: 0 !important;
}

#comparativeBranchReportPage .borderSelect .vs__selected {
  color: rgba(var(--vs-primary), 1) !important;
}

#comparativeBranchReportPage .text-secondaryDark {
  color: rgba(var(--vs-secondaryDark), 1) !important;
}

#comparativeBranchReportPage .vdp-datepicker input {
  height: 35px;
  border: none !important;
  border-bottom: 2px solid rgba(var(--vs-secondaryDark), 1) !important;
  border-radius: 0;
}

#comparativeBranchReportPage .filter-timepicker input {
  width: 100% !important;
  height: 35px !important;
  border-radius: 0;
  border: none !important;
  border-bottom: 2px solid rgba(var(--vs-secondaryDark), 1) !important;
  background: white;
  padding-top: 9px !important;
  padding-bottom: 9px !important;
  padding-left: 11px !important;
}

#comparativeBranchReportPage .vs__selected-options {
  max-height: 35px;
  overflow-y: auto;
}

#comparativeBranchReportPage td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
